<div class="_flex _justify-between _pb-3 _border-b _border-transparency-black-5 _shadow-bottom">
    <div class="_h4">{{data.title}}</div>
    <i class="fa-light fa-xmark _cursor-pointer" mat-dialog-close></i>
</div>

<mat-dialog-content class="_no-scrollbar">
    <div class="_py-4">
        <app-markdown-renderer [text]="data.description"></app-markdown-renderer>
    </div>
</mat-dialog-content>
